import { render, staticRenderFns } from "./ReviewsBottom.vue?vue&type=template&id=1a01571a&scoped=true&"
import script from "./ReviewsBottom.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewsBottom.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewsBottom.vue?vue&type=style&index=0&id=1a01571a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a01571a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a01571a')) {
      api.createRecord('1a01571a', component.options)
    } else {
      api.reload('1a01571a', component.options)
    }
    module.hot.accept("./ReviewsBottom.vue?vue&type=template&id=1a01571a&scoped=true&", function () {
      api.rerender('1a01571a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewsBottom.vue"
export default component.exports